const AddTemplateEvent_mutate = `
  mutation addTemplateEvent(
    $termTemplatePeriodId: Int!
    $eventTypeId: Int!
    $name: String!
    $desc: String 
    $noOfDaysAfter: Int!,
    $attendanceRequired: Boolean!
             
  ) {
    addTemplateEvent(
      termTemplatePeriodId: $termTemplatePeriodId,
      eventTypeId: $eventTypeId,
      name: $name,
      desc: $desc,
      noOfDaysAfter: $noOfDaysAfter,
      attendanceRequired: $attendanceRequired
    ) {
      templateEvent
        {
          termTemplateEventId
          termTemplatePeriodId
          {
            termTemplatePeriodId
            name
          }
          eventTypeId
          {
            eventTypeId
            name
          }
          name
          desc
          attendanceRequired
          noOfDaysAfter
        }
      }
    }
`;

const UpdateTemplateEvent_mutate = `
  mutation updateTemplateEvent(
    $termTemplateEventId:Int!
    $eventTypeId: Int
    $name: String
    $desc: String
    $noOfDaysAfter: Int   
    $attendanceRequired: Boolean
  ){
    updateTemplateEvent(
      termTemplateEventId: $termTemplateEventId,
      eventTypeId: $eventTypeId,
      name: $name,
      desc: $desc,
      noOfDaysAfter: $noOfDaysAfter,
      attendanceRequired: $attendanceRequired
    ){
      templateEvent
        {
          termTemplateEventId
          termTemplatePeriodId
          {
            termTemplatePeriodId
            name
          }
          eventTypeId
          {
            eventTypeId
            name
          }
          name
          desc
          attendanceRequired
          noOfDaysAfter
        }
    }
  }
`;  

const DeleteTemplateEvent_mutate = `
    mutation deleteTemplateEvent($termTemplateEventId: Int!) {
      deleteTemplateEvent(termTemplateEventId: $termTemplateEventId) {
        response
      }
    }
`;

module.exports = {  
  ADD_TEMPLATE_EVENT_MUTATION: AddTemplateEvent_mutate,
  UPDATE_TEMPLATE_EVENT_MUTATION: UpdateTemplateEvent_mutate,
  DELETE_TEMPLATE_EVENT_MUTATION: DeleteTemplateEvent_mutate,
}
